<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
</script>
<template>
  <div
    class="modal fade"
    id="sin-martillero-modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-custom">
      <div class="modal-content">
        <div class="row flex-column flex-sm-row radius-dialog ">
          <div
            class="m-0 p-2 col-12 col-sm-5 radius-left d-flex sans-serif-text flex-column justify-content-center align-items-around nowrap"
            style="background-color: #fff"
          >
          <img
              class="align-self-end d-block d-md-none cursor-pointer"
              src="@/assets/img/illustrations/cierre.svg"
              style="max-width: 20px"
              @click="$emit('closeModal')"
            />
            <img
              src="@/assets/img/illustrations/icono_sin_martillero.png"
              style="max-width: 400px"
            />
          </div>
          <div
            class="m-0 p-3 col-12 col-sm-7 radius-right d-flex flex-column justify-content-center align-items-center wrap"
            style="background-color: #6ec276"
          >
           <img
              class="align-self-end d-none d-lg-block cursor-pointer mb-2"
              src="@/assets/img/illustrations/icono_cierre_modal.svg"
              style="max-width: 20px"
              @click="$emit('closeModal')"
            />
            <p class="text-center text-color-white fw-700 fs-lg-4 fs-5">
              ¡Ofertá en cualquier momento, en cualquier horario!
            </p>
            <p class="text-center text-color-white fs-14 fw-400">
              Tendrás que ingresar una
              <span class="fw-bold">nueva garantía</span> para tener crédito en
              esta nueva modalidad. Ingresá una Garantía haciendo
              <a
                class="text-soft-green fw-600 text-decoration-underline"
                :href="router.resolve({ name: 'Credito'}).href"
                target="_blank"
                >click acá.</a
              >
            </p>
            <p class="text-sm text-color-white text-center mt-5">
              <span class="fw-bold">¿Tenés dudas?</span> Conocé más detalles:
            </p>
            <a 
            class="w-90"
            :href="router.resolve({ name: 'ComoParticipar'}).href"
                  target="_blank"
                  >
              <button  class="w-100 p-2 text-xxs text-color-white boton_popup btn mb-3">
                ¿Cómo participar?
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.radius-dialog {
  border-radius: 5px !important;
}
.radius-left {
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}
.radius-right {
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}
.sans-serif-text {
  font-family: "Roboto Slab";
}
.titulo_sin_martillero {
  color: #6ec276 !important;
  font-weight: 800 !important;
}
.text-color-white {
  color: white !important;
}
.boton_popup {
  background-color: #006c4c;
  border-radius: 2px !important;
}
@media (max-width: 575.98px) {
  .modal-custom {
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }
  .radius-left {
  border-top-left-radius: 5px !important;
    border-bottom-left-radius: 0px !important;
  border-top-right-radius: 5px !important;
  }
  .radius-right {
border-top-right-radius: 0px !important;
    border-bottom-left-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    }

    .modal-dialog.modal-custom {
    margin-top: 100px !important;
  }
}

</style>
